import { jsx } from 'react/jsx-runtime';
import { createContext, useContext } from 'react';
import '@dynamic-labs/utils';
import '@dynamic-labs/sdk-api';
import '../../config/ApiEndpoint.js';
import '../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import '../ViewContext/ViewContext.js';
import '@dynamic-labs/wallet-book';
import '../../utils/constants/colors.js';
import '../../shared/utils/classes/storage/localStorage.js';
import 'ethers';
import '../../shared/consts/index.js';
import '@dynamic-labs/multi-wallet';
import '@dynamic-labs/rpc-providers';
import '../../utils/hooks/useWallets/utils/verifyMagicIsSetup/verifyMagicIsSetup.js';
import '../DynamicContext/DynamicContext.js';
import '../ErrorContext/ErrorContext.js';
import '../AccessDeniedContext/AccessDeniedContext.js';
import '../AccountExistsContext/AccountExistsContext.js';
import 'react-dom';
import '../../components/ShadowDOM/ShadowDOM.js';
import '../ThemeContext/ThemeContext.js';
import 'react-focus-lock';
import '../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../components/Transition/OpacityTransition/OpacityTransition.js';
import '../../components/IconButton/IconButton.js';
import '../../components/Alert/Alert.js';
import '../../components/Popper/Popper/Popper.js';
import '../../components/Popper/PopperContext/PopperContext.js';
import 'formik';
import 'yup';
import '../../components/InlineWidget/InlineWidget.js';
import '../../components/MenuList/Dropdown/Dropdown.js';
import { useDefaultQrCode } from '../../utils/hooks/useDefaultQrCode/useDefaultQrCode.js';
import '../MockContext/MockContext.js';
import '../CaptchaContext/CaptchaContext.js';
import '../../utils/hooks/useUserUpdateRequest/useUserUpdateRequest.js';

const QrCodeContext = createContext(undefined);
const QrCodeContextProvider = ({ children, }) => {
    const { setShowQrCodeImage, setShowQrCodeMessage, showQrCodeImage, showQrCodeMessage, } = useDefaultQrCode();
    const value = {
        setShowQrCodeImage,
        setShowQrCodeMessage,
        showQrCodeImage,
        showQrCodeMessage,
    };
    return (jsx(QrCodeContext.Provider, Object.assign({ value: value }, { children: children })));
};
const useQrCodeContext = () => {
    const context = useContext(QrCodeContext);
    if (context === undefined) {
        throw new Error('usage of useQrCodeContext not wrapped in `QrCodeContextProvider`.');
    }
    return context;
};

export { QrCodeContext, QrCodeContextProvider, useQrCodeContext };
